"use client";

import React from "react";
import Link from "next/link";
import Image from "next/image";
import styles from "./MenuCategoryBlocks.module.scss";

const MenuCategoryBlocks = () => {
  const menuCategories = [
    {
      id: 1,
      title: "STARTERS",
      image: "/images/pages/our-steak/categories/2026/starters.jpg",
      link: "/steakhouse-menu/our-food-menu/starters",
      alt: "Fried halloumi slices garnished with herbs, served with a dipping sauce and a lemon wedge on a black appetizer plate",
    },
    {
      id: 2,
      title: "STEAK AND RIBS",
      image: "/images/pages/our-steak/categories/2026/steak-ribs.jpg",
      link: "/steakhouse-menu/our-food-menu/steak-and-ribs",
      alt: "Juicy grilled beef steak served with golden French fries on a white plate, accompanied by a glass of red wine and a wine bottle in the background",
    },
    {
      id: 3,
      title: "SOUTH AFRICAN FAVOURITES",
      image:"/images/pages/our-steak/categories/2026/south-african-favourites.jpg",
      link: "/steakhouse-menu/our-food-menu/south-african-favourites",
      alt: "Char-grilled steak garnished with fresh rosemary, served on a sizzling platter with a colorful mixed vegetable medley",
    },
    {
      id: 4,
      title: "POULTRY",
      image: "/images/pages/our-steak/categories/2026/poultry.jpg",
      link: "/steakhouse-menu/our-food-menu/poultry",
      alt: "Crumbed schnitzel topped with creamy pepper sauce, served with sautéed spinach, coleslaw, and a lemon wedge on a white plate. A bottle labeled “Sauvignon Blanc” and a wine glass sit in the background",
    },
    {
      id: 5,
      title: "SEAFOOD",
      image: "/images/pages/our-steak/categories/2026/seafood-new.jpg",
      link: "/steakhouse-menu/our-food-menu/seafood",
      alt: "Grilled prawns covered in a creamy white sauce and garnished with chopped chives, served on a baked potato with thick-cut fries and lemon wedges. A glass of white wine is visible in the background",
    },
    {
      id: 6,
      title: "BURGERS",
      image: "/images/pages/our-steak/categories/2026/burger.jpg",
      link: "/steakhouse-menu/our-food-menu/burgers",
      alt: "Open gourmet beef burger with caramelized onions, lettuce, tomato, pickles, and creamy sauce served with thick-cut fries and a glass of beer on a rustic wooden table",
    },
    {
      id: 7,
      title: "COMBOS",
      image:
        "/images/pages/our-steak/categories/2026/combo.jpg",
      link: "/steakhouse-menu/our-food-menu/combos",
      alt: "Restaurant-style mixed grill platter featuring barbecue pork ribs and herb-roasted chicken, served with mashed vegetables, creamed spinach, coleslaw, and a cold beer in the background",
    },
    {
      id: 8,
      title: "SALADS, VEGETARIAN AND VEGAN",
      image: "/images/pages/our-steak/categories/2026/salad.jpg",
      link: "/steakhouse-menu/our-food-menu/salads-vegetarian-vegan",
      alt: "Fresh garden salad with crisp lettuce, red onion rings, walnuts, dried fruit, and blue cheese crumbles, drizzled with olive oil from a bottle above",
    },
    {
      id: 9,
      title: "SAUCES AND EXTRAS",
      image: "/images/pages/our-steak/categories/2026/sauces-extras.jpg",
      link: "/steakhouse-menu/our-food-menu/sauces-extras",
      alt: "Small white ramekin filled with glossy sauce, presented on a black plate with a sprig of fresh rosemary on a rustic wooden tabletop",
    },
    {
      id: 10,
      title: "DESSERTS",
      image: "/images/pages/our-steak/categories/2026/dessert.jpg",
      link: "/steakhouse-menu/our-food-menu/desserts",
      alt: "Traditional South African malva pudding dusted with powdered sugar and topped with a scoop of vanilla ice cream and fresh mint",
    },
    {
      id: 11,
      title: "BEVERAGES",
      image: "/images/pages/our-steak/categories/2026/beverages.jpg",
      link: "/steakhouse-menu/our-food-menu/beverages",
      alt: "Handcrafted cocktail selection featuring a mojito, berry cocktail, frozen margarita, white wine, and fresh fruit garnishes displayed on a wooden bar table",
    },
    {
      id: 12,
      title: "WINE AND OTHERS",
      image: "/images/pages/our-steak/categories/2026/wine.jpg",
      link: "/steakhouse-menu/our-winelist",
      alt: "Bottle of South African Merlot wine and a glass of red wine displayed on a rustic wooden table",
    },
  ];

  return (
    <section className={styles.menuCategorySection}>
      <div className="container">
        <div className="row g-2 justify-content-center">
          {menuCategories.map((category) => (
            <div
              key={category.id}
              className="col-lg-3 col-md-6 col-sm-6 col-12"
            >
              <Link href={category.link} className={styles.categoryLink}>
                <div className={styles.categoryBlock}>
                  <div className={styles.imageContainer}>
                    <Image
                      src={category.image}
                      alt={category.alt}
                      width={300}
                      height={200}
                      className={styles.categoryImage}
                      priority={category.id <= 4} // Prioritize loading for first 4 images
                    />
                    <div className={styles.overlay}>
                      <div className={styles.categoryContent}>
                        <div className={styles.categoryIndicator}></div>
                        <div className={styles.categoryTitle}>
                          {category.title}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MenuCategoryBlocks;
